<template>
  <div
    data-component="UiFileWidget"
    class="min-w-[130px] w-1/5 inline-flex bg-gray-200 rounded p-2 whitespace-normal flex-col flex-grow items-center justify-between gap-4"
    @mouseover="dataIsMouseOver = true"
    @mouseleave="dataIsMouseOver = false"
    >
    <span class="text-sm text-center" v-text="model?.name"/>
    <div class="flex justify-center gap-2 items-center">
      <i v-if="!selected" class="fa fa-check text-gray-400 cursor-pointer" @click="$emit('click')" />
      <i v-else class="fa fa-check text-green-400 cursor-pointer" @click="$emit('click')"/>
      <i title="Open in new tab" class="fas fa-eye cursor-pointer text-gray-400 hover:text-gray-600 transition-all" @click="methodOpenFile"/>
      <i title="Copy link" class="fas fa-link cursor-pointer text-gray-400 hover:text-gray-600 transition-all" @click="methodCopyLinkFile"/>
      <img
        v-if="model?.url && model?.type?.startsWith('image/')"
        :src="model?.url"
        class="max-w-8 w-full"
        >
    </div>
    <span class="text-gray-400 text-xs" v-text="model?.size_human" />
    <small class="text-xs" v-text="moment(model?.created_at).format('YYYY-MM-DD HH:mm')" />
  </div>
  <div
    v-if="dataIsMouseOver && model?.url && model?.type?.startsWith('image/')"
    class="fixed p-2 bg-white transition-all rounded-lg min-w-[200px] min-h-16 shadow z-[9999999]"
    :style="computedPreviewPos"
    >
    <img :src="model?.url" class="max-w-52 object-cover rounded-lg w-full" >
  </div>
</template>

<script setup lang="ts">
import moment from 'moment';

defineEmits(['click'])

const props = defineProps<{
  src?: string,
  selected?: boolean
}>()

const model = defineModel<File>()
const dataIsMouseOver = ref(false)
const dataMousePos = ref({x:0,y:0})

onMounted(() => {
  if(props.src && !model.value){
    methodLoadFileFromSrc()
  }
})

const methodLoadFileFromSrc = () => {
  ws.send<File>('file.loadsrc', {src: props.src}).then((r) => {
    model.value = r
  })
}

const methodOpenFile = () => {
  window.open(model.value?.url, '_blank')
}

const methodCopyLinkFile = () => {
  navigator.clipboard.writeText(model.value?.url as string)

  notify('Link copied to clipboard')
}

const methodMouseMoveHandler = (e) => {
  dataMousePos.value = {x: e.clientX, y: e.clientY}
}

const computedPreviewPos = computed(() => {
  const payload = {
    top: `${dataMousePos.value.y + 10}px`,
    left: `${dataMousePos.value.x + 10}px`,
  }

  return payload;
})

watch(() => dataIsMouseOver.value, (v) => {
  (v)
    ? window.addEventListener('mousemove', methodMouseMoveHandler)
    : window.removeEventListener('mousemove', methodMouseMoveHandler)
})
</script>
